import React, { useRef, useState, useEffect } from "react";
import { Button, Grid, TextField, Typography, RadioGroup, FormControlLabel, FormControl, FormLabel, Radio } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import { repliValidator } from "../../../components";
import useStyles from "./UpdateOrganization.styles";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";

const cookies = new Cookies();

const CreateOrganizationTextField = (props) => {
  return <TextField variant="outlined" margin="normal" fullWidth {...props} />;
};

const UpdateOrganization = () => {
  let history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState('true');
  const { orgId } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [saveResult, setSaveResult] = useState();
  const [redirect, setRedirect] = useState(false);

  const validator = useRef(repliValidator());

  useEffect(() => {
    const loadAccountInfo = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH_SIGNEDUSER}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        let json = await response.json();
        if (!response.ok) {
          console.log(json.message);
          return;
        }

        validator.current.showMessages();
      } catch (error) {
        console.log(error);
        console.log(
          `${t("module.provider.myAccount.message.fetchDataFailure")}. ${t(
            "common.message.error.seeLog"
          )}.`
        );
      }
    };

    loadAccountInfo();
  }, [t]);

  useEffect(() => {
    const getOrganization = async () => {
      try {
        let response = await fetch(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_ORGANIZATION}/${orgId}`,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },
          }
        );
        let json = await response.json();
        if (!response.ok) {
          console.log(json.message || json.errors[0].msg);

          return;
        }
        setEmail(json.email);
        setName(json.name);
        setUrl(json.url);
        setIsActive(JSON.stringify(json.isActive))
      } catch (error) {
        console.log(error);
        console.log(
          `${t(
            "module.provider.editOrganization.message.fetchDataFailure"
          )}. ${t("common.message.error.seeLog")}.`
        );
      }
    };

    getOrganization();
    validator.current.showMessages();
  }, [orgId, t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    const isValid = validator.current.allValid();
    if (!isValid) {
      validator.current.showMessages();
      return;
    }
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_ORGANIZATION}/${orgId}`,
        {
          method: "put",
          headers: {
            "X-ACCESS-TOKEN": cookies.get("token"),
          },
          body: new URLSearchParams({
            email: email,
            url: url,
            name: name,
            id: orgId,
            isActive: isActive
          }),
        }
      );
      if (!response.ok) {
        let json = await response.json();
        let message = " ";
        if (json.errors && json.errors.length > 1) {
          json.errors.forEach((err) => {
            message += " " + err.msg;
          });
          setSaveResult({ severity: "error", message: message });
        } else {
          setSaveResult({
            severity: "error",
            message: json.errors ? json.errors[0].msg : json.message,
          });
        }
        return;
      }
      if (response.status === 201 || response.status === 200) {
        setRedirect(true);
        setSaveResult({
          severity: "success",
          message: t(
            "module.provider.editOrganization.message.editOrganizationSuccess"
          ),
        });
      }
    } catch (error) {
      console.log(error);
      setSaveResult({
        severity: "error",
        message: `${t(
          "module.provider.editOrganization.message.editOrganizationFailure"
        )}. ${t("common.message.error.seeLog")}.`,
      });
    } finally {
    }
  };

  useEffect(() => {
    if (submitted) {

      validator.current.showMessages();
    }
  }, [submitted, validator]);

  useEffect(() => {
    if (redirect) {
      setTimeout(() => {
        return history.push("/provider/organizations");
      }, 2000);
    }
  }, [redirect]);

  return (
    <div>
      <Typography variant="h4" className={classes.title}>
        {t("module.provider.editOrganization.title")}
      </Typography>
      {saveResult && (
        <Alert severity={saveResult.severity}>{saveResult.message}</Alert>
      )}
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CreateOrganizationTextField
              label={`${t("common.form.label.name")}*`}
              autoComplete="off"
              error={submitted && !validator.current.fieldValid("name")}
              helperText={validator.current.message(
                "name",
                name,
                "required|alphaSpaces"
              )}
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
          </Grid>
          <Grid item xs={6}>
            <CreateOrganizationTextField
              label={`${t("common.form.label.email")}*`}
              autoComplete="off"
              autoFocus
              error={!validator.current.fieldValid("email")}
              helperText={validator.current.message(
                "email",
                email,
                "required|email"
              )}
              onChange={(e) => setEmail(e.target.value.trim())}
              value={email}
            />
          </Grid>
          <Grid item xs={6}>
            <CreateOrganizationTextField
              label={`${t("common.form.label.url")}*`}
              autoComplete="off"
              error={submitted && !validator.current.fieldValid("url")}
              helperText={validator.current.message("url", url, "required")}
              onChange={(e) => setUrl(e.target.value.trimStart())}
              value={url}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl style={{ width: '100%', display: 'flex', flexDirection: "row" }} component="fieldset">
              <FormLabel component="legend">Status</FormLabel>
              <RadioGroup
                style={{ display: "flex", flexDirection: "row", width: "100%" }}
                aria-label="isActive"
                name="isActive"
                value={isActive}
                onChange={(e) => setIsActive(e.target.value)}
              >
                <FormControlLabel
                  value={`${true}`}
                  control={<Radio />}
                  label="Active"
                />
                <FormControlLabel
                  value={`${false}`}
                  control={<Radio />}
                  label="InActive"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          style={{ marginTop: 25 }}
        >
          {t("common.form.button.save")}
        </Button>
      </form>
    </div>
  );
};

export default UpdateOrganization;
